export default "__VITE_ASSET__fd911b2b__"